import React, { useRef, useState } from "react";
import { StyledGrid } from "../style/StyledComponents";
import { Button, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { savePodcastBookmarksInNotes } from "../../storage/PodcastLocalStorage";
import { base64UrlEncode, extractPodcastMetadata } from "./podcastUtils";

const PodcastForm = ({rssFeed, setRssFeed, handleSubmit}) => {
    const [error, setError] = useState(false);
    const hiddenFileInput = useRef(null);
    const navigate = useNavigate();

    const handleImportClick = () => {
      hiddenFileInput.current.click();
    };

    const handleImport = (event) => {
      const fileUploaded = event.target.files[0];
      if (!fileUploaded){
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const podcast_form = JSON.parse(text);
        //const podcastMetadata = extractPodcastMetadata(podcast_form.podcastM)
        const podcastDetails = {
          ...podcast_form.podcastMetadata,
          updateTime: Date.now(),
          bookmarks: podcast_form.bookmarks,
          section: podcast_form.section ? podcast_form.section : 0,
        };
        if (podcast_form.podcastMetadata.rssFeed && podcast_form.podcastMetadata.mp3) {
          const encodedPodcast = base64UrlEncode(podcast_form.podcastMetadata.rssFeed);
          const encodedMp3 = base64UrlEncode(podcast_form.podcastMetadata.mp3);
          savePodcastBookmarksInNotes(`${encodedPodcast}#${encodedMp3}`, podcastDetails);
          navigate(`/podcasts/${encodedPodcast}/mp3/${encodedMp3}`/*, { state: { ...podcast_form.podcastMetadata} }*/);
        }
      };
      reader.readAsText(fileUploaded);
    };

    const handleChange = (e) => {
      const val = e.target.value;
      setRssFeed(val);
    };

  return (<>
        <StyledGrid 
          container 
          item
          columns={20}
          spacing={2}
          sx={{
            width: "100%",
            padding: "1rem",
            paddingLeft: "2rem"
           }}>
          <Grid item xs={18} sm={10} md={13}>
            <TextField
              error={error}
              id="rssFeed"
              label="Podcast Rss Feed"
              variant="outlined"
              value={rssFeed}
              size="small"
              fullWidth={true}
              onChange={(e) => {handleChange(e)}}
            />
          </Grid>
          <Grid item xs={16} sm={10} md={7}>
            <Grid container columns={18} spacing={2}>
              <Grid item>
                <Tooltip title="Submit the url to load the video!" size="md" arrow>
                  <Button 
                  variant="contained" 
                  onClick={(e) => handleSubmit(e)}
                  
                  style={{ textTransform: 'capitalize' }}
                  >Submit</Button>
                </Tooltip>
              </Grid>
              <Grid item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant="h6" component="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                OR
              </Typography>
              </Grid>
              <Grid item>
              <Tooltip title="Load clipThoughts' json file with previously saved notes." size="md" arrow>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleImportClick}
                  style={{ textTransform: 'capitalize' }}
                  sx={{ height: '38px'}}
                  >
                  Load
                </Button>
                </Tooltip>
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleImport}
                  style={{ display: 'none' }} // Hide the file input
                />
              </Grid>
            </Grid> 
          </Grid>
        </StyledGrid>  
        </>
        );
}

export default PodcastForm;